import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Document — lines of text appear to be typed one by one.
 *  Uses stroke-dashoffset so the effect is cheap and crisp at 16px. */
export function IcnDoc(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="doc">
      <path d="M3 2h6l3 3v9H3V2z" />
      <path d="M9 2v3h3" />
      <line x1="5" y1="8" x2="11" y2="8" strokeDasharray="6" strokeDashoffset="0">
        {animate && (
          <animate
            attributeName="stroke-dashoffset"
            values="6;0;0;6"
            keyTimes="0;0.25;0.9;1"
            dur="3s"
            repeatCount="indefinite"
          />
        )}
      </line>
      <line x1="5" y1="10.5" x2="10" y2="10.5" strokeDasharray="5" strokeDashoffset="0">
        {animate && (
          <animate
            attributeName="stroke-dashoffset"
            values="5;5;0;0;5"
            keyTimes="0;0.3;0.55;0.9;1"
            dur="3s"
            repeatCount="indefinite"
          />
        )}
      </line>
    </Svg>
  );
}
